// Shared with the API so displayed links and indexed tags use the same rules.
function normalizeHashtag(value) {
  if (typeof value !== 'string') return '';
  const tag = value.normalize('NFKC').trim().replace(/^#/, '').toLowerCase();
  return Array.from(tag).length <= 64 && /^[\p{L}\p{M}\p{N}_]+$/u.test(tag) && /[\p{L}\p{N}]/u.test(tag) ? tag : '';
}

function findHashtags(content) {
  if (typeof content !== 'string') return [];
  // Consume URLs first: a URL fragment is not a hashtag. Keep UTF-16 offsets for slice().
  const pattern = /https?:\/\/\S+|(^|[^\p{L}\p{M}\p{N}_#＃/])([#＃][\p{L}\p{M}\p{N}_]+)/gu;
  const tags = [];
  for (const match of content.matchAll(pattern)) {
    if (!match[2]) continue;
    const tag = normalizeHashtag(match[2]);
    if (tag) tags.push({ tag, label: match[2], start: match.index + match[1].length, end: match.index + match[0].length });
  }
  return tags;
}

module.exports = { normalizeHashtag, findHashtags };
